export default function () {
  return {
    fetched: false,
    all: [],
    one: {},
    pagination: {}
  }
}
